<div class="top">
Confirmation required
</div>
<div class="middle" [innerHTML]="data.message | safeHtml">
</div>
<div class="bottom">
    <button mat-flat-button mat-dialog-close color="warn" (click)="logOut()">{{data.forceLogout !== false ? "LOG OUT" : "CANCEL"}}</button>
    <button mat-flat-button class="confirm-btn" (click)="login()">AUTHORIZE</button>
</div>
